<template>
  <div>
    <div class="display-1 font-weight-normal mb-6 text-center">Vamos começar preenchendo as informações básicas para o login</div>
    <v-row class="mx-auto">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field
            id="usuario-nome"
            v-model="userInfoLocal.nome"
            label="Nome do usuário"
            prepend-icon="mdi-card-account-details"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <v-row class="mx-auto">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" name="E-mail" rules="required|email">
          <v-text-field
            id="usuario-email"
            v-model="userInfoLocal.email"
            label="E-mail"
            prepend-icon="mdi-email"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <v-row class="mx-auto">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field
            id="usuario-login"
            v-model="userInfoLocal.login"
            label="Login"
            prepend-icon="mdi-account"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <v-row class="mx-auto">
      <v-col cols="12">
        <v-text-field
          v-model="userInfoLocal.senha"
          :type="mostrarSenha ? 'text' : 'password'"
          label="Senha"
          prepend-icon="mdi-lock-outline"
          :append-icon="mostrarSenha ? 'mdi-eye' : 'mdi-eye-off'"
          validate-on-blur
          @click:append="mostrarSenha = !mostrarSenha"
        />
      </v-col>
    </v-row>
    <div class="display-1 font-weight-normal mb-6 text-center">Opcionalmente, preencha os demais dados do usuário</div>
    <v-row class="mx-auto">
      <v-col cols="12">
        <v-select
          id="usuario-tipo"
          v-model="userInfoLocal.tipo"
          name="tipo"
          label="Tipo do usuário"
          :items="['COLABORADOR', 'TERCEIRO']"
          class="mb-0 pb-0"
          prepend-icon="mdi-tag"
        />
      </v-col>
    </v-row>
    <v-row class="mx-auto">
      <v-col cols="12">
        <v-text-field id="usuario-cargo" v-model="userInfoLocal.cargo" label="Cargo" prepend-icon="mdi-certificate" />
      </v-col>
    </v-row>
    <v-row class="mx-auto">
      <v-col cols="12">
        <v-text-field id="usuario-diretoria" v-model="userInfoLocal.diretoria" label="Diretoria" prepend-icon="mdi-account-tie" />
      </v-col>
    </v-row>
    <v-row class="mx-auto">
      <v-col cols="12">
        <v-text-field
          id="usuario-area-executiva"
          v-model="userInfoLocal.areaExecutiva"
          label="Área Executiva"
          prepend-icon="mdi-tie"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'FirstTabContent',

    props: {
      userInfo: {
        type: Object,
        default: () => ({
          nome: '',
          login: '',
          senha: '',
          email: '',
          tipo: 'COLABORADOR',
          cargo: 'CARGO PADRÃO',
          diretoria: 'DIRETORIA PADRÃO',
          areaExecutiva: 'ÁREA EXECUTIVA PADRÃO'
        })
      }
    },

    data() {
      return {
        mostrarSenha: false
      };
    },

    computed: {
      userInfoLocal: {
        get() {
          return this.userInfo;
        },
        set(newValue) {
          this.$emit('update:userInfo', newValue);
        }
      }
    }
  };
</script>
